// src/pages/user/About.jsx
import React from 'react';
import { FaUsers, FaAward, FaBullseye, FaEye, FaHandshake, FaStar } from 'react-icons/fa';
import { COMPANY_INFO } from '../../utils/constants';

const About = () => {
  const teamMembers = [
    // {
    //   name: 'Frank Mwamba Chansa',
    //   position: 'Director',
    //   role: 'Contract/Operations Management',
    //   experience: '15+ years in Mining/Contracting'
    // },
    {
      name: 'Kaunda Chimanga',
      position: 'Technical Director',
      role: 'Engineering Design & Construction',
      experience: 'Since 2008'
    },
    {
      name: 'Mutanuka Mobby',
      position: 'Director of Finance',
      role: 'Finance and Accounting Management',
      experience: 'ZICA Registered, CIMA Strategic Level'
    }
  ];

  const achievements = [
    { icon: FaAward, title: '15+ Years', description: 'Industry Experience' },
    { icon: FaUsers, title: '50+', description: 'Satisfied Clients' },
    { icon: FaBullseye, title: '200+', description: 'Projects Completed' },
    { icon: FaStar, title: '6', description: 'Certifications' }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-gray-900 text-white py-20">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">About Brasotech Investments</h1>
            <p className="text-xl text-blue-100">
              Leading Engineering and General Contractors in Zambia, delivering excellence 
              in Civil, Mechanical, and Electrical Engineering since 2008.
            </p>
          </div>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Company Overview</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  Brasotech Investments Limited is a local company specialized in Civil, Mechanical, 
                  and Electrical Engineering, incorporated in 2008 as a private company  
                  
                </p>
                <p>
                  We have the capability and resources to undertake projects of all sizes and 
                  complexity throughout Africa. Our well-qualified and experienced team, coupled 
                  with equally experienced and energetic operation teams, guarantees value-for-money 
                  solutions of the highest standard.
                </p>
                <p>
                  Registered with statutory bodies including PACRA, ZRA, NAPSA, ZPPA, WCFCB, and 
                  NCC, we ensure compliance and quality in all our operations.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-6">
              {achievements.map((achievement, index) => (
                <div key={index} className="bg-blue-50 rounded-xl p-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4">
                    <achievement.icon className="h-8 w-8 text-blue-600" />
                  </div>
                  <div className="text-3xl font-bold text-gray-800 mb-1">{achievement.title}</div>
                  <div className="text-gray-600">{achievement.description}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Vision */}
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-blue-100 rounded-lg mr-4">
                  <FaEye className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Our Vision</h3>
              </div>
              <p className="text-gray-600 text-lg">
                {COMPANY_INFO.vision}
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-green-100 rounded-lg mr-4">
                  <FaBullseye className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Our Mission</h3>
              </div>
              <p className="text-gray-600 text-lg">
                {COMPANY_INFO.mission}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                <FaHandshake className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Honesty & Integrity</h3>
              <p className="text-gray-600">
                Upholding the highest ethical standards and adhering to regulations and procedures
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6">
                <FaUsers className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Customer Service</h3>
              <p className="text-gray-600">
                Building long-term relationships by providing quality and cost-effective products and services
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-6">
                <FaAward className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Quality</h3>
              <p className="text-gray-600">
                Delivering safe, effective products, along with reliable information and service
              </p>
            </div>
            <div className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-6">
                <FaStar className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Teamwork</h3>
              <p className="text-gray-600">
                Collaborating across all levels and departments to achieve our goals
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Management Team - UPDATED SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Management Team</h2>
          <div className="flex flex-wrap justify-center gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg text-center w-full md:w-96">
                <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full mx-auto mb-6"></div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{member.name}</h3>
                <p className="text-blue-600 font-medium mb-3">{member.position}</p>
                <p className="text-gray-600 mb-3">{member.role}</p>
                <p className="text-sm text-gray-500">{member.experience}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Partner with Brasotech Today
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Experience engineering excellence with a company that puts customers first.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
          >
            Get In Touch
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;